import Cookies from 'js-cookie';
import { postSuccessPhp } from '@/api/requests';
import { formatSubmitDataFieldNumberValues } from '@/components/thanks-page';
import { store } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { SliderSlice } from '@/redux/slider';
import Qid from '@/utils/qid';
import Phone from '@/utils/phone';
import Track from '@/utils/track';
import { getZip, setRoute } from '@/utils/helper';

let FAIL_POST_COUNT = 0;

export const sendFormData = (data) => {
  const QID = new Qid();
  const dateFormatToSend = ConfigSlice.selectors.dateFormatToSend(store.getState());
  const enableUploadFiles = ConfigSlice.selectors.enableUploadFiles(store.getState());
  const redirectToOnSubmit = ConfigSlice.selectors.redirectToOnSubmit(store.getState());
  const statics = ConfigSlice.selectors.statics(store.getState());
  const via = ConfigSlice.selectors.via(store.getState());
  const useDynamicLandingPage = ConfigSlice.selectors.useDynamicLandingPage(store.getState());
  const percentDynamicLandingPageOnPrio = ConfigSlice.selectors.percentDynamicLandingPageOnPrio(store.getState());
  const questions = ConfigSlice.selectors.questions(store.getState());
  const calculatedCallDelay = ConfigSlice.selectors.calculatedCallDelay(store.getState());
  const prioCalculatorVersion = ConfigSlice.selectors.prioCalculatorVersion(store.getState());
  const onSuccessPhpResolve = ConfigSlice.selectors.onSuccessPhpResolve(store.getState());
  const rootWithLang = document.querySelector('#root[data-language]');

  if (useDynamicLandingPage && prioCalculatorVersion.selected > 0) {
    // TODO: replace this logic after first refactor round is done
    const headerLabel = document.getElementById('banner-label');
    if (headerLabel) {
      headerLabel.style.display = 'none';
    }
  }

  let params = new URLSearchParams();

  store.dispatch(SliderSlice.actions.setIsFormSubmitted(true));
  store.dispatch(GeneralSlice.actions.setDynamicLandingPageState('loading'));

  if (dateFormatToSend) {
    for (const key in dateFormatToSend) {
      if (dateFormatToSend[key] === 'YYYY-MM-DD' && data[key]) {
        const [DD, MM, YYYY] = data[key].split('/');
        data[key] = `${YYYY}-${MM.padStart(2, '0')}-${DD.padStart(2, '0')}`;
      }
    }
  }

  const formattedData = formatSubmitDataFieldNumberValues(data, questions);

  if (data.email === 'sample@email.tst') {
    return;
  }

  formattedData.leadId = GeneralSlice.selectors.leadId(store.getState());

  Object.keys(formattedData).forEach((key) => params.append(key, formattedData[key]));
  const { callDelayMinutes, openHours } = ConfigSlice.selectors.config(store.getState());
  if (callDelayMinutes && openHours) {
    params.append('callDelayMinutes', calculatedCallDelay);
  }

  if (!Cookies.get('QID')) {
    // Can we use here null instead of default {}?
    // If so need to update type and initial value in GeneralSlice
    params.append('STORED_QUID', GeneralSlice.selectors.qid(store.getState()));
  }

  if (rootWithLang) {
    params.append('funnelLang', rootWithLang.getAttribute('data-language'));
  }

  params.append('browserLang', new Intl.Locale(navigator.language).language);
  params.append('via', via);
  params.append('zip', getZip(data.zip));
  params.append('agb_version', statics ? statics.agb_version : '');
  params.append('vendorConsents', JSON.stringify(QID.vendorConsents));
  params.append('removedClickIds', QID.removedClickIds);
  params.append('phone', Phone.toE164(data.phone ?? ''));
  if (prioCalculatorVersion.selected > 0) {
    params.append('prioCalculatorV2', prioCalculatorVersion.v2);
    params.append('prioCalculatorV3', prioCalculatorVersion.v3);
    params.append('selectedCalculatorVersion', prioCalculatorVersion.selected);
  }
  if (useDynamicLandingPage) {
    params.append('dynamicLandingPage', Number(useDynamicLandingPage));
    params.append('dynamicLandingPagePercent', percentDynamicLandingPageOnPrio);
  }

  postSuccessPhp(params)
    .then((response) => {
      // TODO: What for we need this assignment?
      store.dispatch(GeneralSlice.actions.updateAfterSuccessPhp({ data: response.data, useDynamicLandingPage }));
      Track.DataLayer.SubmitFormResponse(response.data);
      if (response.data.brazeProspect) {
        Track.Experiments.pushProspectEvent();
      } else {
        Track.Experiments.pushLeadEvent();
      }

      setTimeout(() => {
        if (redirectToOnSubmit && !enableUploadFiles) {
          window.open(redirectToOnSubmit.replace('{externalId}', response.data.externalId), '_self');
        } else {
          store.dispatch(SliderSlice.actions.setIsFormSubmissionSuccessful(true));
          setRoute({
            done: true,
            session: GeneralSlice.selectors.session(store.getState()),
            search: GeneralSlice.selectors.windowLocationSearch(store.getState()),
            setSearch: GeneralSlice.actions.setWindowLocationSearch,
          });
        }
        onSuccessPhpResolve?.call(response.data.leadId);
        FAIL_POST_COUNT = 0;
      }, 1000);
    })
    .catch((error) => {
      setTimeout(() => {
        if (error.response && error.response.status === 400) {
          Track.Error.Api(error.response);

          const retryPostRequest = FAIL_POST_COUNT < 10;

          FAIL_POST_COUNT = retryPostRequest ? FAIL_POST_COUNT + 1 : 10;

          store.dispatch(SliderSlice.actions.setIsFormSubmissionFailed(!retryPostRequest));

          Track.DataLayer.NotSuccessfulSubmit();
          if (retryPostRequest) {
            data.repeatedRequest = 1;
            sendFormData(data);
          }
        } else if (error.request) {
          Track.Error.NoResponse(error.request);
        } else {
          Track.Error.Unhandled(error.message);
        }
      }, 30000);
    });
};

export default sendFormData;
